import React from "react";
import PostHeader from "./PostHeader";
import ReactionBar from "./ReactionBar";
import { KUDOS_BADGE_CLASS, VALUE_CHIP_CLASS, initials } from "./constants";

const KudosCard = ({ post, onReacted }) => (
  <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
    <PostHeader post={post} badgeClass={KUDOS_BADGE_CLASS} badgeLabel="Kudos" />

    <div className="px-4 pb-1 pt-3">
      <div className="mb-3 flex items-center gap-3">
        <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full border-2 border-green-500 bg-white text-xs font-semibold text-gray-700">
          {initials(post.recipientName)}
        </span>
        <div className="min-w-0">
          <p className="truncate text-sm text-gray-800">
            Kudos to <span className="font-semibold">{post.recipientName}</span>
          </p>
          {post.recipientCode && (
            <p className="text-xs text-gray-400">#{post.recipientCode}</p>
          )}
        </div>
      </div>

      {post.values.length > 0 && (
        <div className="mb-3 flex flex-wrap gap-2">
          {post.values.map((item) => (
            <span
              key={item.value}
              title={item.description}
              className={`${VALUE_CHIP_CLASS} capitalize`}
            >
              {(item.value || "").toLowerCase()}
            </span>
          ))}
        </div>
      )}

      <p className="mb-3 whitespace-pre-wrap rounded-md bg-gray-50 px-3 py-2.5 text-sm text-gray-700">
        {post.message}
      </p>
    </div>

    <ReactionBar post={post} onReacted={onReacted} />
  </div>
);

export default KudosCard;
